// ── RPmtForm ──
import { fmt } from "../../../shared/format";
import { Btn, FInput, FInputNum, Field, Modal, ReadOnlyForm } from "../../../shared/ui";
import { useFreshForm } from "../../../shared/hooks";
import { NotesPanel } from "../components/NotesPanel";
import { useApp } from "../../../shared/appContext";

export const RPmtForm = ({ initial, spmtId, readOnly  }) => {
    const { role, view, modal, setModal, closeModal, saving, error, saveRec } = useApp();
    const returnTo = modal?.returnTo;
    const handleClose = () => {
      if (returnTo) setModal(returnTo);
      else closeModal();
    };


    const [f, set] = useFreshForm(initial||{
      receiveddate:"", receivedprincipal:"", receivedinterest:"",
      receivedother:"", receivedfee:"", receivedpassthrough:"",
      reversaldate:"", paymentapplieddate:"", record_id_deprecated:"",
      scheduledpmtid:spmtId
    }, "ReceivedPmts");
    const total = (
      (parseFloat(f.receivedprincipal)||0) +
      (parseFloat(f.receivedinterest)||0) +
      (parseFloat(f.receivedother)||0) +
      (parseFloat(f.receivedfee)||0) +
      (parseFloat(f.receivedpassthrough)||0)
    ).toFixed(2);

    return <Modal title={readOnly?"View Received Payment":initial?"Edit Received Payment":"Add Received Payment"} onClose={handleClose} wide

            onEdit={readOnly&&role.isservicer?()=>{ setModal({
              type:"rpmt-edit", rec:initial, returnTo,
              // Where to land afterwards, and who to tell.
              //
              // `returnTo` is the scheduled payment we arrived from, when we
              // arrived from one. It now carries that page's reload on its own
              // onDone, so restoring it WHOLE rather than rebuilding it keeps
              // the reload attached — an edit made after this one refreshes as
              // well, instead of this being the point the chain goes quiet.
              //
              // With no returnTo this payment was opened straight from a list,
              // so we come back to the payment itself. The previous fallback
              // opened a SCHEDULED payment view holding a RECEIVED payment
              // record, which rendered a form full of blanks.
              onDone:()=>{
                if (returnTo && returnTo.onDone) returnTo.onDone();
                else if (modal && modal.onDone) modal.onDone();
                setModal(returnTo || { type:"rpmt-view", rec:initial, onDone:modal && modal.onDone });
              },
            }); }:null}>


      <ReadOnlyForm readOnly={readOnly}>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr 1fr", gap:"0 24px" }}>
      <Field label="Received Date"><FInput value={f.receiveddate?.slice(0,10)||""} onChange={set("receiveddate")} type="date" /></Field>
      <Field label="Payment Applied Date"><FInput value={f.paymentapplieddate?.slice(0,10)||""} onChange={set("paymentapplieddate")} type="date" /></Field><div></div>
      <Field label="Reversal Date"><FInput value={f.reversaldate?.slice(0,10)||""} onChange={set("reversaldate")} type="date" /></Field>
      <Field label="Principal"><FInputNum value={f.receivedprincipal} onChange={set("receivedprincipal")} /></Field>
      <Field label="Interest"><FInputNum value={f.receivedinterest} onChange={set("receivedinterest")} type="number" /></Field><div></div><div></div>
      <Field label="Fee"><FInputNum value={f.receivedfee} onChange={set("receivedfee")} type="number" /></Field>
      <Field label="Other"><FInputNum value={f.receivedother} onChange={set("receivedother")} type="number" /></Field><div></div><div></div>
       <Field label="Pass-through"><FInputNum value={f.receivedpassthrough} onChange={set("receivedpassthrough")} type="number" /></Field> <div></div><div></div>
      <Field label="Total Payment">
        <div style={{ padding:"7px 10px", fontSize:13, borderRadius:4, border:"1px solid #ddd", background:"#f5f5f5", color:"#333", fontWeight:500 }}>{fmt(total)}</div>
      </Field>
      </div>
      </ReadOnlyForm>
      {initial?.id && <NotesPanel scope="record" entitytype="ReceivedPmt" entityid={initial.id} accountid={f.accountid} loanid={f.loanid} source="Received Pmt" />}
      {error&&<div style={{ color:"#993C1D",fontSize:12,marginBottom:8 }}>{error}</div>}
      <div style={{ display:"flex",gap:8,justifyContent:"flex-end",marginTop:8 }}>
        <Btn onClick={handleClose}>{readOnly?"Close":"Cancel"}</Btn>{!readOnly&&<Btn disabled={saving} onClick={()=>saveRec("saveReceivedPmt",{...f, totalreceivedpmt:total, scheduledpmtid:f.scheduledpmtid||spmtId},initial?"Edited":"Added","ReceivedPmts",(initial?"Updated":"Added")+" received pmt",modal.onDone)} variant="primary">{saving?"Saving...":"Save"}</Btn>}
      </div>
    </Modal>;
  };
